import { initialState as unsavedChangesInitialState } from './reducer'

type RootState = {
  unsavedChanges: typeof unsavedChangesInitialState
}

export const selectUnsavedChangesState = (state: RootState) =>
  state.unsavedChanges || unsavedChangesInitialState
